var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "21px",
    viewBox: "0 0 28 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube ico MENU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 27.9394485 0 27.9394485 19.9520489 0 19.9520489"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Design-v10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8-Footer",
    transform: "translate(-258.000000, -301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    transform: "translate(76.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "YTB",
    transform: "translate(168.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube-ico-MENU",
    transform: "translate(14.000000, 17.888889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2124788,10.3769235 L10.5724788,14.0541713 C10.368903,14.1522141 10.1337515,14.002367 10.1337515,13.774844 L10.1337515,6.19044037 C10.1337515,5.95961468 10.3751455,5.81007339 10.5790848,5.91435474 L18.2190848,9.82144954 C18.4462364,9.93759633 18.442297,10.2663425 18.2124788,10.3769235 M22.1367818,-1.83486239e-05 L5.80266061,-1.83486239e-05 C2.59793333,-1.83486239e-05 -6.06060606e-06,2.62175535 -6.06060606e-06,5.85594495 L-6.06060606e-06,14.0961896 C-6.06060606e-06,17.330318 2.59793333,19.9520917 5.80266061,19.9520917 L22.1367818,19.9520917 C25.3415091,19.9520917 27.9394485,17.330318 27.9394485,14.0961896 L27.9394485,5.85594495 C27.9394485,2.62175535 25.3415091,-1.83486239e-05 22.1367818,-1.83486239e-05",
    id: "Fill-1",
    fill: "#F1EDE4",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYt);
export default __webpack_public_path__ + "static/media/icon_yt.d22ccf7c5421391957181d8c1812903a.svg";
export { ForwardRef as ReactComponent };